import apiClient from '../client';

/** What anyone running the company day to day keeps current. */
export interface CompanyDetails {
  _id: string;
  name: string;
  /** Where new drivers report on their first day. */
  address: string;
  /** When they report, "HH:mm". The server answers 08:30 when unset. */
  reportTime: string;
}

const CompanyService = {
  async mine(): Promise<CompanyDetails> {
    return apiClient.get('/api/companies/my-company') as any;
  },

  /** AO, CA and BC. An empty reportTime goes back to 08:30. */
  async saveMine(body: Partial<Pick<CompanyDetails, 'name' | 'address' | 'reportTime'>>): Promise<CompanyDetails> {
    return apiClient.put('/api/companies/my-company', body) as any;
  },
};

export default CompanyService;
